<template>
  <div class="100% loginPage" >

    <!--<amplify-authenticator></amplify-authenticator>-->
    <div v-if="jumping" style="padding-top: 100px">
      <b-row> 
        <b-col sm="12" class="text-center">
        <h5>{{$t('loading')}}</h5>
        <div class="sk-wave">
            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
        </div>
        </b-col>
      </b-row>
    </div>
    <div v-if="!jumping" class="container-fluid">
      <b-row class="justify-content-center">       
        <b-col offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 
                
                <!--- login form --> 
                <b-form v-if="confirmedUser" class="justify-content-center img-fluid">
                  <div class="d-flex justify-content-center mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                  </div>

                  <!-- login email -->
                  <b-form-group>
                    <label for="login-email">{{this.$t("signup.emailAddress")}}</label>
                    <b-form-input v-model="email" type="text" class="form-control typo-input"/>
                  </b-form-group>

                  <!-- login password -->
                  <b-form-group>
                    <label class="float-left">{{this.$t("signup.password")}}</label>
                    <b-button  @click="gotoPasswordDimenticata" variant="link" class="float-right typo-linkgrey">{{$t("signup.forgotpassword")}}</b-button>
                    <b-form-input v-model="password" type="password" class="form-control typo-input"/>
                  </b-form-group>

                  <!-- Alert da utilizzare in caso utente non riconosciuto alla login -->
                  <b-row class="mt-2 justify-content-center">
                    <b-alert
                      :show="dismissCountDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged">
                    <p>{{ alertMessage }}</p>
                    </b-alert>
                  </b-row>  

                  <!-- Accedi -->
                  <div class="d-flex justify-content-center mb-3">
                    <b-button pill @click="accediClicked" variant="primary" class="px-5 mt-3 but-pill"><span class="text-pill">{{$t("signup.accedi")}}</span></b-button>
                  </div>
                  <!-- Registrazione -->
                  <div class="d-flex justify-content-center">
                    <label class="typo-black">{{this.$t("signup.notSignup")}}</label>
                    <b-button @click="gotoRegistrati" variant="link" class="typo-linkblue ml-2">{{this.$t("signup.nowSignup")}}</b-button>
                  </div>
                </b-form>

                <!--- not confirmed user form-->
                <!-- INSERIMENTO CODICE DI VERIFICA  -->
                <b-form v-if="!confirmedUser">
                      <!-- logo -->
                      <div class="d-flex justify-content-center mt-5 mb-4">
                          <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                      </div>
                      
                      <!-- codice conferma -->
                      <div class="d-flex justify-content-center">
                          <b><p class="typo-title">{{$t("signup.userNotConfirmed")}}</p></b>
                      </div>
                      <div class="d-flex justify-content-center">
                          <b><p class="typo-title">{{$t("signup.completeReg")}}</p></b>
                      </div>
                      <div class="d-flex justify-content-center mb-3">    
                          <p>{{this.$t("signup.insertCode")}}</p>
                      </div>

                      <b-form-group>
                          <label for="codice">{{this.$t("signup.code")}}</label>
                          <b-form-input v-model="code" type="text" :state="validation_code" class="typo-input mb-4"/>
                          <b-form-invalid-feedback style="max-width:250px" :state="validation_code">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                      </b-form-group>

                          <!-- Alert da utilizzare in caso di errore nell'inserimento del codice di conferma -->
                          <b-alert
                                :show="dismissCountDown"
                                dismissible
                                variant="danger"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged">
                              <p>{{ alertMessage }}</p>
                              </b-alert>

                        <div class="d-flex justify-content-center mb-5">      
                          <b-button pill @click="confermaReg" variant="primary" class="px-4 but-pill">{{this.$t("signup.confirmReg")}}</b-button>
                        </div>

                  </b-form> 

        </b-col>
        <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
          <b-col sm="12" offset-xl="1" xl="6" lg="7" md="12" class="pull-right">
              <div style="overflow: hidden">
                <img class="img-login" src="/img/login.png" />
              </div>
          </b-col>  
        </hide-at>
      </b-row>
    </div>

  </div>
  
</template>

<script>
import Vue from 'vue'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
  name: 'Login',
  components: {
    hideAt, showAt
  },
  props: [],
  data() {
      return {
          email: '',
          password: '',
          signedIn: false,
          currUser: null,
          accedi:false,
          dismissSecs: 5,
          dismissCountDown: 0,
          alertMessage:"",
          jumping: false,
          confirmedUser: true,
          code: '',
          saveCode:false,
      }
  },
  computed: {
    validation_code() {
      if (this.saveCode == true) return this.code.length > 0;
    },
  },
  methods: {
    
    gotoRegistrati() {
      this.$router.push('/registrati');
    },
    gotoPasswordDimenticata(
    ) {
      this.$router.push('/passworddimenticata');
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
      },
    accediClicked() {
      console.log("cliccato accedi!");
      this.accedi=true;
      this.$store.state.user = {};
      this.$store.state.userAllPlants = null;
      Auth.signIn(this.email.toLowerCase(),this.password)
      .then(user => {

        console.log(user);

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$store.state.user=user;
          this.$router.push('/setpassword');
        } else {
          this.$store.commit('setLoggedUser',user);
          this.signedIn = true;
          this.$store.state.loading = true;
          this.$router.push('/');
        }
      })
      .catch(err => {console.log("login error", err);
        console.log("Error message: " + err.message);

        if (err.code == "UserNotConfirmedException") 
        {
          // user not confirmed , viene visualizzato il form di reinserimento del codice di verifca
          this.confirmedUser = false;
          return;
        }

        else if (err.code == "NotAuthorizedException")
        {

          // user name o password non corretti
          if (err.message.includes("Incorrect username or password"))
          {
            this.alertMessage = this.$t("signup.errorAut");
          }

          // troppi tentativi di accesso
          if (err.message.includes("Password attempts exceeded")) {
            this.alertMessage = this.$t("signup.maximumAttemptsExceeded");
          }

        }

        // altre exception di tipo notAuthorized
        else
          {
            this.alertMessage = err.message;
          }
        
        this.showAlert();
      });
    },

    //conferma registrazione da utilizzare solo per utenti non cnfermati che non hanno terminato il processo si registrazione inserendo il codice di verifica
    //il fomr di inserimento del codice di verifica ricompare per ritentare la validazione utente
    confermaReg() {
        this.saveCode=true;
        console.log("cliccato confermaReg! " + this.code);
        if (!this.validation_code) return
        Auth.confirmSignUp(this.email,this.code).then(
            user => {
                console.log("signup complete! ", user);  
                this.signedIn=false;
                this.confirmCode = true;
            this.confirmedUser = true;
                //this.$store.commit('firstLogin',{});
            }
        ).catch(
          err => {
              console.log(err);
              this.alertMessage=this.$t("signup."+err.code);
              this.showAlert();
          }
        )
    },

  },
  beforeCreate() {
     console.log("login beforeCreate, route params:", this.$route);
      AmplifyEventBus.$on('authState', info => {
        console.log("authState:",info)
        if (info === 'signedIn') {
            this.signedIn = true
            this.$router.push('/')
        }
      });

      Auth.currentAuthenticatedUser().then(user => {

          this.signedIn = true
      }).catch(() => this.signedIn = false)
  },
  mounted() {
    console.log("login mounted, route params:", this.$route.query.jump);
    if (this.$route.query.jump == 'true') {
      console.log("signed in:" + this.signedIn);
      this.jumping = true;
      if (!this.signedIn) {
        this.$store.state.loading = true;
        this.accedi=true;
        this.$store.state.user = {};
        this.$store.state.userAllPlants = null;
        var queryParams = this.$route.query;
        var self = this;
        Auth.signIn(queryParams.u.toLowerCase(),queryParams.p)
        .then(user => {

          console.log("user after login-redirect:", user);

          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            self.$store.state.user=user;
            self.$router.push('/setpassword');
          } else {
            self.$store.commit('setLoggedUser',user);
            self.signedIn = true;
            self.$store.state.loading = true;
            /*window.setTimeout(()=>{
              Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: queryParams.plant } });
              self.$router.replace({ name: 'HomeImpianto', params: { pid: queryParams.plant } })
            }, 2000);*/
            self.$store.dispatch('checkSocketConnection',{maxWait: 10000}).then((resp) => {
              if (resp) {
                Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: queryParams.plant } });
                self.$router.replace({ name: 'HomeImpianto', params: { pid: queryParams.plant } });
              } else {
                self.jumping = false;
                self.signedIn = false;
                self.$store.state.loading = false;
                self.alertMessage=this.$t("signup.errorAut");
                self.showAlert();
              }
            });
          }
        })
        .catch(err => {console.log("login error", err);
          if (err.code == "UserNotConfirmedException") {
            self.completeReg = true;
            self.jumping = false;
            return;
          }

          self.alertMessage=this.$t("signup.errorAut");
          self.showAlert();
        });
      } else {
        self.$store.state.loading = true;
        self.$store.dispatch('checkSocketConnection',{maxWait: 10000}).then((resp) => {
          if (resp) {
            Vue.prototype.$socket.sendObj({ action: 'getPlantDetails', data: { plantId: queryParams.plant } });
            self.$router.replace({ name: 'HomeImpianto', params: { pid: queryParams.plant } });
          } else {
            self.jumping = false;
            self.signedIn = false;
            self.$store.state.loading = false;
            self.alertMessage=this.$t("signup.errorAut");
            self.showAlert();
          }
        });
      }
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 767px) {
  .loginPage {
    height: 100%;
    margin-top: 0px;
}

  .loginPanel {
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 20%;
    padding-top: 10px;
    border-radius: 10px;
  }

  .pwdButton {
    color: #000000;
    font-size: 16px;
  }

}

.auth {
  margin: 0 auto;
  width: 460px;
}
</style>
